// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"76ebf39c","359":"a1d454a1","730":"255c6556","905":"42f2a3e6","961":"16a6ad33","981":"f51172eb"}[chunkId] + ".chunk.css";
};